var map = {
	"./decidim/avatar-multiuser.png": 63711,
	"./decidim/brands/google.svg": 88518,
	"./decidim/cc-badge.png": 96341,
	"./decidim/decidim-logo.svg": 73709,
	"./decidim/default-avatar.svg": 52765,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 66531,
	"./decidim/icons.svg": 94636,
	"./decidim/pattern.png": 34447,
	"./decidim/placeholder-card-g.svg": 83796,
	"./decidim/placeholder-card-l.svg": 44623,
	"./decidim/placeholder.jpg": 41814,
	"./decidim/remixicon.symbol.svg": 85980,
	"./decidim/vendor/leaflet/layers-2x.png": 82981,
	"./decidim/vendor/leaflet/layers.png": 22204,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 25613,
	"./decidim/vendor/leaflet/marker-icon.png": 73108,
	"./decidim/vendor/leaflet/marker-shadow.png": 12907,
	"./decidim/vendor/social-share-button/douban.svg": 78895,
	"./decidim/vendor/social-share-button/email.svg": 3595,
	"./decidim/vendor/social-share-button/facebook.svg": 27812,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 37936,
	"./decidim/vendor/social-share-button/hacker_news.svg": 68860,
	"./decidim/vendor/social-share-button/linkedin.svg": 83070,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 19767,
	"./decidim/vendor/social-share-button/pinterest.svg": 25814,
	"./decidim/vendor/social-share-button/reddit.svg": 2636,
	"./decidim/vendor/social-share-button/telegram.svg": 91233,
	"./decidim/vendor/social-share-button/tumblr.svg": 68177,
	"./decidim/vendor/social-share-button/twitter.svg": 65877,
	"./decidim/vendor/social-share-button/vkontakte.svg": 3111,
	"./decidim/vendor/social-share-button/wechat.svg": 44722,
	"./decidim/vendor/social-share-button/whatsapp.svg": 99698,
	"./decidim/vendor/social-share-button/x.svg": 12440,
	"./decidim/vendor/social-share-button/xing.svg": 86704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95311;